import React from 'react'
import { Grid, Container } from '@material-ui/core'
import ContainerLogin from './ContainerLogin'
import DiscoveryPlatform from './DiscoverPlatform'

const SectionLogin = () =>{
  return(
    <Container maxWidth={'lg'}>
      <Grid container direction='column' >
        <ContainerLogin/>
        <DiscoveryPlatform/>
      </Grid>
    </Container>
  )
}

export default SectionLogin;
